<template>
  <v-container :class="isSPSize ? 'sp' : ''">
    <v-row>
      <v-col cols="12">
        <h1 :class="h1Style" class="title-border">
          About us
        </h1>
        <p class="mb-4 indent">Paike (pronounced “pike”) was started with a vision to connect people through a mutual language of “Passion&Like” for free. We aim to help:</p>
        <ul class="mb-4">
          <li>Locals who are not fluent in a second language such as English who want to have fun with international travelers without hesitation and</li>
          <li>Travelers who want to interact with locals rather than just visiting places in a guidebook.</li>
        </ul>
        <p class="caption">
          ※ Traveler is a person who is traveling internationally.<br>
          　 Local is a person living in the country where the traveler is traveling to.<br>
          　 Paike out means for a traveler and local to meet through Paike and have fun.
        </p>
        <p class="mb-4">This vision was born from Tommy, the founder’s actual experiences.</p>
        <p class="font-weight-bold textBlack--text mb-0">
          1. Living in the United States without fluent English:
        </p>
        <p class="mb-0 indent">
          When he started living in the San Francisco Bay Area, he spoke only entry-level English. Yet he found himself having fun with locals who have the same “Passion&Like” as him.
        </p>
        <p class="mb-0 indent">
          For example, he met Tony while mountain biking at Tilden Regional Park, and Daniel, at a local brewery. Because mountain biking and beer were their mutual “Passion&Like," fluent English was not required to have fun.
        </p>
        <p class="mb-4 indent">
          “Passion&Like” acted as the mutual language.
        </p>

        <p class="font-weight-bold textBlack--text mb-0">
          2. The founder’s pleasure from discovering beyond a guidebook:
        </p>
        <p class="indent mb-2">
          When he traveled alone in Taiwan, China, Tunisia, Greece, and Italy with only his backpack and bicycle he had the most fun when he found himself discovering places that were not in a guidebook or when he interacted with the local people; a young man who he met in an unnamed town in southern Tunisia surrounded by desert; a free ride to karaoke from a friendly police officer in Lhasa, Tibet; a magnificent view of the southern Italian countryside recommended by a local bicyclist, Leonardo; and a local farmer who invited him to visit a rural village with a nostalgic ambience in Sicily.
        </p>
        <p class="indent mb-4">
          These people and experiences were not in a guidebook; Tommy doesn’t even remember the names or the exact locations anymore. Nevertheless, the irreplaceable experiences have been his treasure ever since.
        </p>
        <p class="indent mb-0">
          On May 5, 2019, the idea of Paike struck him while jogging in Pleasanton Ridge Regional Park.
        </p>
        <p class="indent mb-0">
          While the number of travelers is increasing rapidly worldwide, most of them see only tourist-areas from a guidebook and stay in a hotel without interacting with the locals. Even when they hire a local tour guide it doesn’t lead to a friendship.
        </p>
        <p class="indent mb-0">
          Travelers are missing an opportunity to experience something new and make friends. Paike provides a platform to connect travelers and locals who have the mutual Passion&Like to communicate across languages while having fun when traveling. And it’s free!
        </p>
        <p class="indent mb-0">
          Language can be a real barrier. We strongly feel it everyday in the United States. But if you share the same “Passion&Like," it will become the mutual language.
        </p>
        <p class="indent mb-4">
          Take a step forward. Relax. Just as you hang out with your friends. Don’t worry about the language differences. Let’s “Paike out”!
        </p>
        <p class="mb-4">
          ※Since Paike is under beta version, we are limiting Paike features and Paikeout areas. We are planning to add available areas as well as other functional features, so please look forward to the future updates! Also, we would love to build "Paike" with you. Any feedbacks and comments are welcome:)
        </p>
      </v-col>
      <v-col cols="12">
        <h1 :class="h1Style" class="title-border">
          Company
        </h1>
        <p class="font-weight-bold textBlack--text mb-0">
          Name
        </p>
        <p class="mb-4 indent">
          Attic Start Inc.
        </p>
        <p class="font-weight-bold textBlack--text mb-0">
          Date founded
        </p>
        <p class="mb-4 indent">
          June 27th 2019
        </p>
        <p class="font-weight-bold textBlack--text mb-0">
          CEO
        </p>
        <p class="mb-4 indent">
          Keisuke Tommy
        </p>
        <p class="font-weight-bold textBlack--text mb-0">
          Head Office
        </p>
        <p class="mb-4 indent">
          2-5-3 Nagatacho GRID 5F, Hirakawa-cho, Chiyoda-ku, Tokyo, Japan
        </p>
        <p class="font-weight-bold textBlack--text mb-0">
          Branch Office
        </p>
        <p class="mb-4 indent">
          2-6-11 fgn. Daimyou, Chuo-ku, Fukuoka-shi, Fukuoka, Japan
        </p>
        <p class="font-weight-bold textBlack--text mb-0">
          Contact
        </p>
        <p class="mb-4 indent">
          <a href="mailto:support@paikeout.com">support@paikeout.com</a>
        </p>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn
          rounded
          large
          dark
          align-items="center"
          color="gray"
          width="250"
          class="font-weight-bold text-capitalize"
          @click="$router.go(-1)"
        >
          Back
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    h1Style() {
      return this.isSPSize
        ? 'font-h1-sp font-weight-bold mb-3'
        : 'font-h1-pc font-weight-bold mb-5'
    },
    isSPSize() {
      return this.$vuetify.breakpoint.name === 'xs'
    },
  },
  data: () => ({
  }),
};
</script>

<style lang="stylus" scoped>
.indent
  text-indent 1em

p
  line-height 1.5
  font-size 15px

p.caption
  font-size 0.8rem

.sp
  p, ul, ol
    font-size 12px
</style>